import { render, staticRenderFns } from "./PatnerFormModal.vue?vue&type=template&id=50495b26&"
import script from "./PatnerFormModal.vue?vue&type=script&lang=js&"
export * from "./PatnerFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports